// client.ts

import { createPromiseClient } from "@connectrpc/connect";
import { createConnectTransport } from "@connectrpc/connect-web";
import { AccountService } from "schema/gen/es/chiikipoint/companyconsole/v2/account_service_connect.js";
import { CompanyService } from "schema/gen/es/chiikipoint/companyconsole/v2/service_connect";
import { AccountService as StoreAccountService } from "schema/gen/es/chiikipoint/storeconsole/v2/account_service_connect";
import { StoreService } from "schema/gen/es/chiikipoint/storeconsole/v2/service_connect";
import {
  accountServiceMockTransport,
  companyServiceMockTransport,
} from "./mocks/company";
import {
  storeAccountServiceMockTransport,
  storeServiceMockTransport,
} from "./mocks/store";
import { isMockEnv } from "./utils";

const accountTransport = createConnectTransport({
  baseUrl: "/",
});

const createCompanyTransport = ({ token }: { token: string }) =>
  createConnectTransport({
    baseUrl: "/",
    interceptors: [
      (next) => async (req) => {
        req.header.set("Authorization", `Bearer ${token}`);
        return next(req);
      },
    ],
  });

export const createAccountClient = () => {
  const mock = isMockEnv();
  return createPromiseClient(
    AccountService,
    mock ? accountServiceMockTransport : accountTransport,
  );
};

export const createStoreAccountClient = () => {
  const mock = isMockEnv();
  return createPromiseClient(
    StoreAccountService,
    mock ? storeAccountServiceMockTransport : accountTransport,
  );
};

type CreateCompanyClientParams = {
  token: string;
  mock?: boolean;
};

export type CompanyClient = ReturnType<
  typeof createPromiseClient<typeof CompanyService>
>;

export type StoreClient = ReturnType<
  typeof createPromiseClient<typeof StoreService>
>;

export const createCompanyClient = ({ token }: CreateCompanyClientParams) => {
  const mock = isMockEnv();
  return createPromiseClient(
    CompanyService,
    mock ? companyServiceMockTransport : createCompanyTransport({ token }),
  );
};

export const createStoreClient = ({ token }: CreateCompanyClientParams) => {
  const mock = isMockEnv();
  return createPromiseClient(
    StoreService,
    mock ? storeServiceMockTransport : createCompanyTransport({ token }),
  );
};
